import React from "react";

export const CountersBand = ({ counters }) => {
  if (!counters || !counters.length) return null;
  return (
    <section className="border-t hairline" data-testid="counters-band">
      <div className="max-w-[1240px] mx-auto px-5 lg:px-8 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 text-center sm:text-left">
          {counters.map((c) => (
            <div key={c.label} className="sm:border-l sm:first:border-l-0 sm:pl-6 sm:first:pl-0" style={{ borderColor: "#E4E7EC" }}>
              <div className="text-4xl font-bold text-asphalt">{c.value}</div>
              <div className="text-[14px] text-mutedink mt-2 leading-snug">{c.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
